module.exports = __webpack_public_path__ + "static/media/advantage-cswap-x-midnight-2.07387320.png";